import React, { useState, Fragment, useEffect } from 'react';
import styles from './Applications.module.css';
import { Row, Col, Card, Tooltip, Space, Spin, Button, Input, Typography, Table, Select, message, Modal, Tag, Popover } from 'antd';
import { CloudDownloadOutlined, OrderedListOutlined, SearchOutlined, SyncOutlined } from '@ant-design/icons';
import { fetchTrend, fetchUserVal, fetchJsData, fetchJs2Data } from '../../../../api';
import 'chartjs-plugin-datalabels';
import { FetchSslTabSearch } from './SslTab';
import { FetchUcTabSearch } from './UcTab';
import { FetchApiConnector } from './ApiConnector';
import { OpenMod } from './AppModal';
import { CSVLink } from 'react-csv';
import { InfoCircleOutlined, ArrowLeftOutlined } from '@ant-design/icons';
const { Text } = Typography;
const { Option } = Select;
const { Search } = Input;

const fetchUserSearch = async (rel) => {
    const data = await fetchJsData({
        type: 'fetch',
        qry: 'fetConAppsOwn',
        preProcess: true,
        preProcFunc: 'catAppOwnGen',
        firstVal: rel,
        secondVal: rel,
        thirdVal: rel,
        fourthVal: rel,
        fifthVal: rel,
        sixthVal: rel,
        seventhVal: rel,
        eighthVal: rel,
        ninthVal: rel,
    });
    return data;
};

const Applications = () => {
    const [rel, setRel] = useState(null);
    const [usrRel, setUsrRel] = useState('');
    const [relState, setRelState] = useState(true);
    const [load, setLoad] = useState(true);
    const [limiter, setLimiter] = useState(12);
    const [submit, setSubmit] = useState(true);

    const [renderer, updateRender] = useState('tab1');
    const onTabChng = (key) => {
        updateRender(key);
        setSubmit(!submit);
    };

    useEffect(() => {
        if (!rel) {
            fetchData();
        }
    }, [rel]);

    const fetchData = async () => {
        setLoad(true);
        const relVersion = await fetchTrend('fetConVersion');
        // setRel("snapshot_" + relVersion["version"]);
        setRel(relVersion['curVersion']);
        setUsrRel('snapshot_v' + relVersion['curVersion'] + '_0_0');
        setLoad(false);
    };

    const contentList = {
        tab1: <FetchTabSearch submit={submit} rel={rel} usrRel={usrRel} type="own" />,
        tab2: <FetchUcTabSearch submit={submit} rel={rel} usrRel={usrRel} type="uc" />,
        tab3: <FetchSslTabSearch submit={submit} rel={rel} usrRel={usrRel} type="ssl" />,
        tab4: <FetchApiConnector submit={submit} rel={rel} usrRel={usrRel} type="ssl" />,
    };

    function onChange(value) {
        message.info(`Release snapshot_v${value}_0_0`);
        setUsrRel('snapshot_v' + value + '_0_0');
        setLimiter(parseInt(value));
        setSubmit(!submit);
    }

    return (
        <div>
            {/* date range filter */}
            <Row type="flex" style={{ margin: '5px', padding: '1px' }}>
                <Col className="gutter-row" span={1}></Col>
                <Col className="gutter-row" span={14}>
                    <Card bordered={false} style={{ height: 70, margin: '1px', padding: '1px' }}>
                        <Space>
                            {load ? (
                                <div>
                                    <Spin size="small" />
                                </div>
                            ) : (
                                <Select
                                    showSearch
                                    // defaultValue={usrRel}
                                    style={{ width: 400 }}
                                    placeholder="Select Release"
                                    optionFilterProp="children"
                                    onChange={onChange}
                                    defaultValue={rel}
                                >
                                    <Option value={rel}>Release {rel}</Option>
                                    <Option value={rel - 1}>Release {rel - 1}</Option>
                                    <Option value={rel - 2}>Release {rel - 2}</Option>
                                    <Option value={rel - 3}>Release {rel - 3}</Option>
                                    <Option value={rel - 4}>Release {rel - 4}</Option>
                                </Select>
                            )}
                        </Space>
                    </Card>
                </Col>
            </Row>

            {/* Card */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className="gutter-row" span={1}></Col>
                <Col className="gutter-row" span={22}>
                    {load ? (
                        <div className={styles.spinner}>
                            <Spin size="small" />
                        </div>
                    ) : (
                        <Card
                            style={{ width: '100%' }}
                            // title="Card title"
                            // extra={<a href="#">More</a>}
                            tabList={tabList}
                            // activeTabKey={tabList[0]["key"]}
                            onTabChange={onTabChng}
                        >
                            {contentList[renderer]}
                        </Card>
                    )}
                </Col>
            </Row>
        </div>
    );
};

const FetchTabSearch = (props) => {
    const [load, setLoad] = useState(props.load);
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(true);
    const [app, setApp] = useState('');
    const [appEntData, setAppEntData] = useState({});
    const [trig, setTrig] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [testStatusModalVis, setTestStatusModalVis] = useState(false);
    const [testStatusCount, setTestStatusCount] = useState({
        pass: 0,
        partial: 0,
        fail: 0,
    });
    // const [show, setShow] = useState(false);
    // const openModal = () => setShow(true);
    // const closeModal = () => setShow(false);
    const rel = props.usrRel.replace('snapshot_v', '').replace('_0_0', '');
    const [relTestResult, setRelTestResult] = useState({});
    const ColOwn = [
        {
            title: () => {
                return (
                    <>
                        Application name{' '}
                        {loading ? (
                            <div>
                                <Spin size="small" />
                            </div>
                        ) : (
                            <Tag color="processing">{filteredData.length}</Tag>
                        )}
                    </>
                );
            },
            dataIndex: 'current_name',
            key: 'current_name',
            fixed: 'left',
            width: '25%',
            sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
            render: (text, record) => (
                <Space size="middle">
                    <Tooltip title={record.application_name}>
                        <a
                            onClick={() => {
                                setApp(record.current_name);
                                setAppEntData({
                                    appName: record.current_name,
                                    appId: record.application_id,
                                });
                                setOpenModal(true);
                                setTestStatusModalVis(false);
                                setTrig(!trig);
                                // openModal();
                            }}
                        >
                            {record.current_name}
                        </a>
                    </Tooltip>
                </Space>
            ),
        },
        {
            title: 'Category Name',
            dataIndex: 'category_name',
            key: 'category_name',
            sorter: (a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 1),
            fixed: 'left',
            width: '15%',
        },
        {
            // title: "Priority",
            title: () => {
                return (
                    <>
                        Priority <Tag color="processing">{filteredData.filter((it) => it.priority.includes('P1')).length}</Tag>
                    </>
                );
            },
            dataIndex: 'priority',
            key: 'priority',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => (a.priority ? a.priority.localeCompare(b.priority) : 1),
            fixed: 'left',
            width: '10%',
        },
        {
            // title: "Instance support",
            title: () => {
                return (
                    <>
                        Instance support <Tag color="processing">{filteredData.filter((it) => it.instance_support == 'Yes').length}</Tag>
                    </>
                );
            },
            dataIndex: 'instance_support',
            key: 'instance_support',
            sorter: (a, b) => (a.instance_support ? a.instance_support.localeCompare(b.instance_support) : 1),
            fixed: 'left',
            width: '15%',
            render: (text, record) => {
                return (
                    <>
                        {record.instance_description == null || record.instance_description == '' ? (
                            <span>{text}</span>
                        ) : (
                            <Popover
                                title={record.current_name}
                                content={() => {
                                    return (
                                        <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                            {record.instance_description?.split(/\n/).map((i) => {
                                                return <li>{i}</li>;
                                            })}
                                        </ul>
                                    );
                                }}
                            >
                                <a>{text}</a>
                            </Popover>
                        )}
                    </>
                );
            },
        },
        {
            // title: "Synthetic support",
            title: () => {
                return (
                    <>
                        Synthetic support{' '}
                        <Tag color="processing">
                            {filteredData.filter((it) => it.synthetic_support != '' && it.synthetic_support != null).length}
                        </Tag>
                    </>
                );
            },
            dataIndex: 'synthetic_support',
            key: 'synthetic_support',
            sorter: (a, b) => (a.synthetic_support ? a.synthetic_support.localeCompare(b.synthetic_support) : 1),
            fixed: 'left',
            width: '15%',
        },
        {
            title: 'DLP',
            dataIndex: 'dlp',
            key: 'dlp',
            sorter: (a, b) => a.dlp - b.dlp,
            fixed: 'left',
            width: '5%',
        },
        {
            title: 'TSS',
            dataIndex: 'tss',
            key: 'tss',
            sorter: (a, b) => a.tss - b.tss,
            fixed: 'left',
            width: '5%',
        },
        {
            title: 'Test Status',
            dataIndex: 'test_status',
            key: 'test_status',
            fixed: 'left',
            width: '10%',
            sorter: (a, b) => (a.test_status ? a.test_status.localeCompare(b.test_status) : 1),
            showSorterTooltip: {
                title: () => {
                    return (
                        <ul>
                            <li>
                                <p>
                                    <Text type="success">Pass</Text>: {testStatusCount.pass}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <Text style={{ color: '#fd8204' }}>Partial Pass</Text>: {testStatusCount.partial}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <Text type="danger">Fail</Text>: {testStatusCount.fail}
                                </p>
                            </li>
                        </ul>
                    );
                },
            },

            render: (text, record) => {
                return (
                    <>
                        {text == '' || text == 'Untested' ? (
                            text
                        ) : (
                            <a
                                onClick={() => {
                                    setApp(record.current_name);
                                    setTestStatusModalVis(true);
                                    setOpenModal(false);
                                    setTrig(!trig);
                                }}
                            >
                                <span
                                    style={{
                                        color: text == 'Fail' ? 'red' : text == 'Partial Pass' ? '#fd8204' : 'green',
                                    }}
                                >
                                    {text}
                                </span>
                            </a>
                        )}
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        setLoading(true);
        const crawl = (user, allValues) => {
            if (!allValues) allValues = [];
            for (var key in user) {
                if (typeof user[key] === 'object') crawl(user[key], allValues);
                else allValues.push(user[key] + ' ');
            }
            return allValues;
        };
        const fetchData = async () => {
            const { data: users } = await fetchUserSearch(props.usrRel);
            const fetRelTestRe = await fetchJsData({
                type: 'fetch',
                qry: 'fetConRelTestRe',
                firstVal: props.usrRel,
                secondVal: 'R-' + rel,
            });
            let relTest = {};
            let testCount = { pass: 0, partial: 0, fail: 0 };
            fetRelTestRe['data'].map((i) => {
                relTest[i.current_name] = i.result.includes('Fail') ? 'Fail' : i.result.includes('Partial Pass') ? 'Partial Pass' : 'Pass';
            });

            setTestStatusCount(testCount);
            let u = users.map((i) => {
                if (Object.keys(relTest).length > 0) {
                    if (Object.keys(relTest).includes(i.current_name)) {
                        i['test_status'] = relTest[i.current_name];
                        if (relTest[i.current_name] == 'Fail') testCount.fail += 1;
                        if (relTest[i.current_name] == 'Partial Pass') testCount.partial += 1;
                        if (relTest[i.current_name] == 'Pass') testCount.pass += 1;
                    } else {
                        i['test_status'] = 'Untested';
                    }
                } else {
                    i['test_status'] = '';
                }
                return i;
            });
            setRelTestResult(relTest);
            setOrigData(u);
            setFilteredData(u);
            const searchInd = users.map((user) => {
                const allValues = crawl(user);
                return { allValues: allValues.toString() };
            });
            setSearchIndex(searchInd);
            if (users) setLoading(false);
        };
        fetchData();
    }, [props.submit]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.submit]);

    return (
        <>
            <div>
                <Row gutter={16}>
                    <Col className="gutter-row" span={1}></Col>
                    <Col span={22}>
                        <Card
                            title={'Release - ' + props.usrRel.split('snapshot_v')[1].split('_')[0]}
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                            extra={
                                <Row>
                                    <Col span={21}>
                                        <Input
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            prefix={<SearchOutlined className="site-form-item-icon" />}
                                            placeholder="Crawl Search"
                                            allowClear
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col className="gutter-row" span={2}>
                                        {' '}
                                        <div>
                                            {loading ? (
                                                <div>
                                                    <Spin size="small" />
                                                </div>
                                            ) : (
                                                <Tooltip
                                                    placement="topRight"
                                                    title="Download App Connector Report"
                                                    arrowPointAtCenter
                                                    // color={"#CCD1D1"}
                                                    // key={"#2db7f5"}
                                                >
                                                    <CSVLink
                                                        filename={'App Connector Report.csv'}
                                                        data={filteredData}
                                                        className="btn btn-primary"
                                                    >
                                                        <CloudDownloadOutlined style={{ fontSize: '29px' }} />
                                                    </CSVLink>
                                                </Tooltip>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            }
                        >
                            <Fragment>
                                <Table
                                    rowKey="application_id"
                                    size="small"
                                    bordered
                                    scroll={{ x: 550, y: 900 }}
                                    style={{ margin: '2px' }}
                                    dataSource={filteredData}
                                    columns={ColOwn}
                                    loading={loading}
                                    pagination={{
                                        pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                        defaultPageSize: ['50'],
                                        showSizeChanger: true,
                                    }}
                                />
                            </Fragment>
                            <Fragment>
                                <OpenMod
                                    usrRel={props.usrRel}
                                    rel={props.rel}
                                    type={props.type}
                                    app={app}
                                    appEntData={appEntData}
                                    openModal={openModal}
                                    trig={trig}
                                />
                            </Fragment>
                        </Card>
                    </Col>
                </Row>
                <Fragment>
                    <TestStatusModal
                        app={app}
                        rel={rel}
                        usrRel={props.usrRel}
                        testStatusModalVis={testStatusModalVis}
                        trig={trig}
                    ></TestStatusModal>
                </Fragment>
            </div>
        </>
    );
};

const TestStatusModal = (props) => {
    const [app, setApp] = useState(props.app);
    const [loading, setLoading] = useState(true);
    const [modalData, setModalData] = useState({ appActList: '' });
    const [innerModal, setInnerModal] = useState(false);
    const [selAct, setSelAct] = useState('');
    const [show, setShow] = useState(false);
    const [trig, setTrig] = useState(props.trig);
    const openModal = () => setShow(props.testStatusModalVis);
    const closeModal = () => {
        setShow(false);
        setSelAct('');
        setInnerModal(false);
    };

    useEffect(() => {
        setLoading(true);
        const fetchActDetails = async () => {
            const fetConAppAct = await fetchJsData({
                type: 'fetch',
                qry: 'fetConAppActDom',
                firstVal: props.app,
                secondVal: props.usrRel,
                thirdVal: props.usrRel,
                fourthVal: props.usrRel,
                fifthVal: props.usrRel,
                sixthVal: props.usrRel,
            });

            const fetchTestResult = await fetchJsData({
                type: 'fetch',
                qry: 'fetConTestRe',
                firstVal: props.usrRel,
                secondVal: props.usrRel,
                thirdVal: props.app,
                fourthVal: 'R-' + props.rel,
            });

            let testRe = {};
            fetchTestResult['data'].map((i) => {
                testRe[i.activity_name] = i.result.includes('Fail')
                    ? 'Fail'
                    : i.result.includes('Partial Pass')
                    ? 'Partial Pass'
                    : i.result.includes('Pass')
                    ? 'Pass'
                    : 'Untested';
            });
            setModalData({
                appActList: fetConAppAct['data'][1][0]['activityV1'],
                appActResultStatus: testRe,
            });
            setLoading(false);
        };
        if (props.testStatusModalVis === true) {
            setApp(props.app);
            openModal();
            fetchActDetails();
        }
    }, [props.app, props.trig]);

    return (
        <>
            <Modal
                title={
                    loading ? (
                        <Spin size="small" />
                    ) : (
                        <Row>
                            <Col span={23}>
                                <Text keyboard>{app}</Text>
                            </Col>
                            <Col span={1}>
                                <Tooltip
                                    title={
                                        <div
                                            style={{
                                                fontSize: '9px',
                                                fontFamily: 'Gill, Helvetica, sans-serif',
                                            }}
                                        >
                                            <ul>
                                                <li>
                                                    <Text type="success">Pass</Text>
                                                </li>
                                                <li>
                                                    <Text style={{ color: '#fd8204' }}>Partial Pass</Text>
                                                </li>
                                                <li>
                                                    <Text type="danger">Fail</Text>
                                                </li>
                                                <li>
                                                    <Text style={{ color: 'grey' }}>Untested</Text>
                                                </li>
                                            </ul>
                                        </div>
                                    }
                                    color="#425162"
                                    // style={{ width: "700px" }}
                                >
                                    <InfoCircleOutlined />
                                </Tooltip>
                            </Col>
                        </Row>
                    )
                }
                open={show}
                onCancel={closeModal}
                width="60%"
            >
                {loading ? (
                    <Spin size="small" />
                ) : (
                    <Card size="small" title={<Text keyboard> Activity </Text>} headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}>
                        {modalData.appActList.split(',').map((act, i) => {
                            return (
                                <>
                                    {Object.keys(modalData.appActResultStatus).includes(act) ? (
                                        <>
                                            <a
                                                onClick={() => {
                                                    setInnerModal(true);
                                                    setSelAct(act);
                                                    setShow(false);
                                                    setTrig(!trig);
                                                }}
                                            >
                                                {modalData.appActResultStatus[act] == 'Fail' ? <b style={{ color: 'Red' }}>{act}</b> : null}
                                                {modalData.appActResultStatus[act] == 'Partial Pass' ? (
                                                    <b style={{ color: '#fd8204' }}>{act}</b>
                                                ) : null}
                                                {modalData.appActResultStatus[act] == 'Pass' ? (
                                                    <b style={{ color: 'Green' }}>{act}</b>
                                                ) : null}
                                                {modalData.appActResultStatus[act] == 'Untested' ? (
                                                    <b style={{ color: 'grey' }}>{act}</b>
                                                ) : null}
                                            </a>
                                        </>
                                    ) : (
                                        <>{act}</>
                                    )}

                                    {modalData.appActList.split(',').length - 1 == i ? '' : ', '}
                                </>
                            );
                        })}
                    </Card>
                )}
            </Modal>

            <Fragment>
                <TestStatusModalInner
                    usrRel={props.usrRel}
                    rel={props.rel}
                    modalTitle={selAct}
                    app={app}
                    innerModal={innerModal}
                    parentModal={setInnerModal}
                    parentShow={setShow}
                    parentSelAct={setSelAct}
                    trig={trig}
                ></TestStatusModalInner>
            </Fragment>
        </>
    );
};

const TestStatusModalInner = (props) => {
    const tableRowColor = (text, record) => {
        return (
            <span
                style={{
                    color:
                        record.result == 'Fail'
                            ? 'red'
                            : record.result == 'Partial Pass'
                            ? '#fd8204'
                            : record.result == 'Pass'
                            ? 'green'
                            : record.result == 'Untested'
                            ? 'grey'
                            : 'black',
                }}
            >
                {text}
            </span>
        );
    };

    const colActTestRe = [
        {
            title: 'Browser',
            dataIndex: 'browser',
            key: 'browser',
            fixed: 'left',
            width: '20%',
            render: tableRowColor,
        },
        {
            title: 'OS',
            dataIndex: 'os',
            key: 'os',
            fixed: 'left',
            width: '20%',
            render: tableRowColor,
        },
        {
            title: 'Result',
            dataIndex: 'result',
            key: 'result',
            fixed: 'left',
            width: '20%',
            render: tableRowColor,
        },
        {
            title: 'Pass',
            dataIndex: 'pass_tc_count',
            key: 'pass_tc_count',
            fixed: 'left',
            width: '10%',
            render: tableRowColor,
        },
        {
            title: 'Fail',
            dataIndex: 'fail_tc_count',
            key: 'fail_tc_count',
            fixed: 'left',
            width: '10%',
            render: tableRowColor,
        },
        {
            title: 'Untested',
            dataIndex: 'untested_tc_count',
            key: 'untested_tc_count',
            fixed: 'left',
            width: '10%',
            render: tableRowColor,
        },
    ];

    const [modalTitle, setModalTitle] = useState(props.modalTitle);
    const [loading, setLoading] = useState(true);
    const [modalData, setModalData] = useState({ testReTableData: [] });

    const [show, setShow] = useState(false);
    const openModal = () => setShow(props.innerModal);
    const closeModal = () => {
        setShow(false);
        props.parentSelAct('');
    };
    const backModal = () => {
        setShow(false);
        props.parentShow(true);
        props.parentSelAct('');
        setModalTitle('');
    };

    useEffect(() => {
        setLoading(true);
        const fetchTestResult = async () => {
            const fetAppActTestRe = await fetchJsData({
                type: 'fetch',
                qry: 'fetConTestReAct',
                firstVal: props.usrRel,
                secondVal: props.usrRel,
                thirdVal: props.modalTitle,
                fourthVal: props.app,
                fifthVal: 'R-' + props.rel,
            });
            setModalData({ testReTableData: fetAppActTestRe['data'] });
            setLoading(false);
        };
        if (props.innerModal === true) {
            fetchTestResult();
        }
    }, [modalTitle, props.trig]);

    useEffect(() => {
        if (props.modalTitle != '') {
            setModalTitle(props.modalTitle);
            if (props.innerModal === true) {
                openModal();
            }
        }
    }, [props.modalTitle]);
    return (
        <>
            <Modal
                title={
                    loading ? (
                        <Spin size="small" />
                    ) : (
                        <>
                            <ArrowLeftOutlined
                                onClick={() => {
                                    backModal();
                                }}
                            />
                            <Text keyboard>
                                {props.app} {'-> '} {modalTitle}
                            </Text>
                        </>
                    )
                }
                open={show}
                onOk={closeModal}
                confirmLoading={loading}
                onCancel={closeModal}
                width="50%"
            >
                {loading ? (
                    <Spin size="small" />
                ) : (
                    <Card size="small" title="Platform wise test result" headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}>
                        <Table
                            size="small"
                            bordered
                            dataSource={modalData.testReTableData}
                            columns={colActTestRe}
                            pagination={false}
                            loading={loading}
                        ></Table>
                    </Card>
                )}
            </Modal>
        </>
    );
};

const tabList = [
    {
        key: 'tab1',
        tab: 'App Connector',
    },
    {
        key: 'tab2',
        tab: 'CASB Universal Connector',
    },
    {
        key: 'tab3',
        tab: 'Ssl Pinned',
    },
    {
        key: 'tab4',
        tab: 'Api Connector',
    },
];

export default Applications;
